var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumMobileBtn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36.527,
    viewBox: "0 0 41 36.527",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-350.5 -96.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 41,
    transform: "translate(350.5 98.5)",
    fill: "none",
    stroke: "#1b246a",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 41,
    transform: "translate(350.5 114.763)",
    fill: "none",
    stroke: "#1b246a",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 41,
    transform: "translate(350.5 131.027)",
    fill: "none",
    stroke: "#1b246a",
    strokeWidth: 4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumMobileBtn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-mobile-btn.421ed570.svg";
export { ForwardRef as ReactComponent };